import React from "react"
import logoUrl from "../../../assets/img/payment-icons/diners_club.svg"

export default function DinersClubLogo({ sx }: { sx: React.CSSProperties }) {
    return (
        <img
            src={logoUrl} loading="lazy"
            alt="Diners Club logo"
            style={sx}
        />
    )
}
